<section class="job-calendar-page">
  <section class="job-calendar-layout-card">
  <header class="page-header">
    <div>
      <h1 class="main-heading sam-page-heading">JOBBKALENDER</h1>
    </div>

    <button mat-raised-button color="accent" class="create-button" (click)="goToPreNotification()">
      Föranmäl nytt jobb
    </button>
  </header>

  <p class="intro-text">Här ser du dina arbetade datum och vilka datum som är föranmälda.</p>

  <div class="section-surface">
    <section class="job-calendar-section">
    <header class="section-heading">
      <span class="section-heading-icon" aria-hidden="true"><mat-icon>date_range</mat-icon></span>
      <div>
        <h2>1. Datumöversikt</h2>
      </div>
    </header>

    <div class="section-content calendar-section-content">
    <div class="calendar-grid">
      <div class="calendar-wrapper">
        <mat-calendar
          #calendarCurrent
          [startAt]="calendarStart"
          [selected]="selectedDate"
          [dateClass]="dateClass"
          (selectedChange)="onCalendarDateSelected($event)"
        ></mat-calendar>
      </div>

      <div class="calendar-wrapper">
        <mat-calendar
          #calendarNext
          [startAt]="nextCalendarStart"
          [selected]="selectedDate"
          [dateClass]="dateClass"
          (selectedChange)="onCalendarDateSelected($event)"
        ></mat-calendar>
      </div>
    </div>

    <div class="legend">
      <div class="legend-item">
        <span class="dot dot-worked"></span>
        <span>Arbetat datum</span>
      </div>
      <div class="legend-item">
        <span class="dot dot-prenotified"></span>
        <span>Föranmält datum</span>
      </div>
    </div>
    </div>
    </section>

    <section class="job-calendar-section invoice-section">
    <header class="section-heading">
      <span class="section-heading-icon" aria-hidden="true"><mat-icon>receipt_long</mat-icon></span>
      <div>
        <h2>2. Fakturor</h2>
      </div>
    </header>

    <div class="section-content invoice-section-content">
    <div class="table-state" *ngIf="selectedDate">
      Visar fakturor för {{ selectedDate | swedishDate: 'yyyy-MM-dd' }}.
      <button mat-button color="accent" type="button" (click)="clearDateSelection()">Visa standardlista</button>
    </div>

    <div class="table-filters" *ngIf="!isLoading && !loadError">
      <div class="search-box">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input
          type="search"
          aria-label="Sök kund"
          placeholder="Sök kund"
          [ngModel]="customerSearch"
          (ngModelChange)="onCustomerSearchChange($event)"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>

      <mat-form-field appearance="fill" floatLabel="never" class="filter-field date-field compact-filter-field no-subscript">
        <input
          matInput
          aria-label="Startdatum från"
          placeholder="Startdatum från"
          [matDatepicker]="fromPicker"
          [(ngModel)]="filterDateFrom"
          (dateChange)="onFilterDateChange('from')"
          [ngModelOptions]="{ standalone: true }"
        />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" floatLabel="never" class="filter-field date-field compact-filter-field no-subscript">
        <input
          matInput
          aria-label="Slutdatum till"
          placeholder="Slutdatum till"
          [matDatepicker]="toPicker"
          [(ngModel)]="filterDateTo"
          (dateChange)="onFilterDateChange('to')"
          [ngModelOptions]="{ standalone: true }"
        />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button
        mat-icon-button
        type="button"
        class="clear-filters"
        (click)="clearTableFilters()"
        [disabled]="!customerSearch && !filterDateFrom && !filterDateTo"
        aria-label="Rensa filter"
        matTooltip="Rensa filter"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="table-state error" *ngIf="!isLoading && loadError">{{ loadError }}</div>

    <div class="job-table-shell" *ngIf="!loadError">
    <div class="job-table-scroll">
    <div class="table-skeleton" *ngIf="isLoading" aria-label="Laddar jobbkalender">
      <div class="skeleton-row" *ngFor="let row of [1, 2, 3, 4, 5]">
        <span class="skeleton-cell skeleton-number"></span>
        <span class="skeleton-cell skeleton-customer"></span>
        <span class="skeleton-cell skeleton-date"></span>
        <span class="skeleton-cell skeleton-date"></span>
        <span class="skeleton-cell skeleton-status"></span>
        <span class="skeleton-cell skeleton-action"></span>
        <span class="skeleton-cell skeleton-action"></span>
      </div>
    </div>

    <div class="table-state table-empty" *ngIf="!isLoading && preNotifiedJobsDataSource.data.length === 0">
      Inga jobb att visa.
    </div>

    <mat-table
      class="job-calendar-table job-calendar-desktop-table"
      [class.job-calendar-table-hidden]="isLoading || preNotifiedJobsDataSource.data.length === 0"
      [dataSource]="preNotifiedJobsDataSource"
      #preNotifiedSort="matSort"
      matSort
      [matSortActive]="preNotifiedSortBy"
      [matSortDirection]="preNotifiedSortDirection"
      matSortDisableClear
      (matSortChange)="sortPreNotifiedData($event)"
    >
      <ng-container matColumnDef="invoiceNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Fakturanr</mat-header-cell>
        <mat-cell *matCellDef="let row"><span class="invoice-number">{{ row.InvoiceNumber || '–' }}</span></mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Kund</mat-header-cell>
        <mat-cell *matCellDef="let row"><strong class="customer-name">{{ row.CustomerName || '–' }}</strong></mat-cell>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Första datum</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.StartDate ? (row.StartDate | swedishDate: 'yyyy-MM-dd') : '-' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sista datum</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.EndDate ? (row.EndDate | swedishDate: 'yyyy-MM-dd') : '-' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="preNotificationStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Föranmäld-status</mat-header-cell>
        <mat-cell *matCellDef="let row"><span class="status-pill">{{ row.PreNotificationStatus || '–' }}</span></mat-cell>
      </ng-container>

      <ng-container matColumnDef="editPreNotification">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-stroked-button color="primary" type="button" class="job-table-action" (click)="editPreNotification(row)" [disabled]="!canEditPreNotification(row)">
            Redigera föranmälan
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="editWorkedTime">
        <mat-header-cell *matHeaderCellDef>Åtgärder</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-stroked-button color="primary" type="button" class="job-table-action" (click)="editWorkedTime(row)" [disabled]="!row?.InvoiceId">
            Redigera arbetad tid
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <mat-accordion class="job-mobile-cards" multi="false">
      <mat-expansion-panel *ngFor="let row of preNotifiedJobsDataSource.data">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="job-mobile-summary">
              <strong>{{ row.InvoiceNumber ? 'Faktura ' + row.InvoiceNumber : 'Faktura' }}</strong>
              <span>{{ row.CustomerName || 'Ingen kund angiven' }}</span>
              <span class="job-mobile-status">{{ row.PreNotificationStatus || 'Ej föranmäld' }}</span>
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="job-mobile-details">
          <div><span>Första datum</span><strong>{{ row.StartDate ? (row.StartDate | swedishDate: 'yyyy-MM-dd') : '-' }}</strong></div>
          <div><span>Sista datum</span><strong>{{ row.EndDate ? (row.EndDate | swedishDate: 'yyyy-MM-dd') : '-' }}</strong></div>
          <div><span>Föranmäld-status</span><strong>{{ row.PreNotificationStatus || '-' }}</strong></div>

          <div class="job-mobile-actions">
            <button mat-stroked-button color="primary" type="button" (click)="editWorkedTime(row)" [disabled]="!row?.InvoiceId">
              Redigera arbetad tid
            </button>
            <button mat-stroked-button color="primary" type="button" (click)="editPreNotification(row)" [disabled]="!canEditPreNotification(row)">
              Redigera föranmälan
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    </div>

    <mat-paginator
      [class.job-calendar-paginator-hidden]="isLoading || preNotifiedJobsDataSource.data.length === 0"
      #preNotifiedPaginator
      [length]="preNotifiedTotalCount"
      [pageSize]="preNotifiedPageSize"
      [pageIndex]="preNotifiedPageIndex"
      [pageSizeOptions]="[10, 25, 50, 100]"
      [showFirstLastButtons]="true"
      (page)="onPreNotifiedPageChange($event)"
    ></mat-paginator>
    </div>
    </div>
    </section>
  </div>
  </section>
</section>
